<template>
  <div :class="$style['BILL_DELIVER']">
    <pt-form-item label="上传报告PDF文件：" labelWidth="145px" class="form-item">
      <el-upload ref="qualityFile" class="upload-demo" v-model="form.qualityFile" name="qualityFile"  action="aaa" :auto-upload="false" :multiple="false" :on-change="changHandler" :on-success="uploadSuccess">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <!-- <a :href="$privateResourcesUrlDownload + this.tenant+ '/templates/样本提取质控模板.xlsx'">
        <el-button type="text">下载文件模版</el-button>
      </a> -->
      <!-- <el-button size="small" :class="$style.reviewBtn" type="primary" @click="onreview">预览</el-button> -->
    </pt-form-item>
    <pt-form-item label="报告快递单号:" labelWidth="145px">
			<el-input v-model="form.expressNum" placeholder="请填写快递单号"></el-input>
		</pt-form-item>
    <pt-form-item label="备注" labelWidth="145px">
      <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="form.comment" class="texta"></el-input>
    </pt-form-item>
  </div>
</template>

<script>
import { validate } from 'utils/validate'
import { nextTrust } from '../status.js'
export default {
  props: {
    order: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    orderStatus: [Array]
  },
  computed: {
    
  },
  data () {
    return {
      title: '待交付',
      form: {
        result: 'REPORT_GENERATE',
        qualityFile: [],
        validateDnaExtractResult: true
      },
      loading: false,
      submitList: [],
      paramsData: {},
    }
  },
  methods: {
    formValidata () {
      return validate(this, this.form)
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.form.qualityFile = fileList
      console.log('this.form', this.form)
    },
    uploadSuccess () {
      console.log('-----上传完成-------')
    },
    getData (arr) {
      var newArr = []
      arr.forEach(ele => {
        ele.order.orderStatusResult = ele.statusDetail.orderStatusResult
        newArr.push(ele.order)
      })
      console.log('newArr===', newArr)
      return newArr
    },
    next () {
      if (this.mock) {
        return this.mockSubmit()
      } else {
        if (this.submitList.length > 0) {
          console.log('submitLsi00t', this.submitList)
          return nextTrust.call(this, this.paramsData)
        } else {
          return Promise.reject(new Error('请重新上传文件'))
        }
      }
    },
    mockSubmit () {
      let data = {
        orderIds: [this.order.id],
        action: this.status
      }
      if (this.form.result !== 'QUALIFIED') {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result,
          comment: this.form.comment
        }
      } else {
        data.orderStatusDetail = {
          orderStatusResult: this.form.result
        }
      }
      return next.call(this, data, false)
    }
  }

}
</script>

<style module lang="less">
.BILL_DELIVER {
  margin-bottom: 20px;
  :global .tableList .el-table td {
    padding: 0.1rem 0 !important;
  }
  :global .form-item {
    position: relative;
  }
  .reviewBtn {
    position: absolute;
    left: 260px;
    top: 11px;
  }
}
</style>
